import {Injectable} from '@angular/core';
import {AbstractProdSelectService, IProdSelectProperties} from 'prod-select';

@Injectable({providedIn: 'root'})
export class TimezoneService extends AbstractProdSelectService {
  override selectDataUrl: string = 'getTimezones';
  override selectProperties: IProdSelectProperties = {
    id: 'id',
    name: 'id'
  };
}
